import * as React from 'react'
import styled from 'styled-components'
import { ThemeName } from '../../../lib/constants'

export interface GroupProps {
  children: React.ReactNode
  theme?: ThemeName
}

const StyledGroup = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const Group = ({ children }: GroupProps) => {
  return <StyledGroup>{children}</StyledGroup>
}
